import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconImage({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M7.808 15.495 4.222 18.63c.16.198.395.333.661.364L5 19h3.37l1.642-1.578-2.204-1.927zM17 8H5a1 1 0 0 0-.993.883L4 9v8.537l3.467-3.029a.524.524 0 0 1 .681 0l2.564 2.24 4.27-4.107a.522.522 0 0 1 .702-.011L18 14.697v1.297l-2.646-2.364L9.769 19H17a1 1 0 0 0 .993-.883L18 18V9a1 1 0 0 0-1-1zm2 8.917a1 1 0 0 0 .993-.884l.007-.116V7.083a1 1 0 0 0-1-1H8a1 1 0 0 0-.993.884L7.004 7H17a2 2 0 0 1 2 2v7.917zM7 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm10 10H5a1.999 1.999 0 0 1-1.704-.952l-.018-.03a1.997 1.997 0 0 1-.056-.102l.074.132a2.022 2.022 0 0 1-.157-.315A1.994 1.994 0 0 1 3 18V9a2 2 0 0 1 2-2h1a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2 2 2 0 0 1-2 2z"/>
        </svg>
    );
}

export default IconImage;
